import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import HeaderDomesticSearchProxy from '../proxies/HeaderDomesticSearchProxy'

class HeaderDomesticSearchService extends ServiceBase {
  postHeaderDomesticSearch(params) {
    return this.getData(() =>
      HeaderDomesticSearchProxy.postHeaderDomesticSearch(params),
    )
  }

  postHeaderSearchHistories(params) {
    return this.getData(() =>
      HeaderDomesticSearchProxy.postHeaderSearchHistories(params),
    )
  }

  getHeaderSearchHistories(params) {
    return this.getData(() =>
      HeaderDomesticSearchProxy.getHeaderSearchHistories(params),
    )
  }

  deleteHeaderSearchHistories(params) {
    return this.getData(() =>
      HeaderDomesticSearchProxy.deleteHeaderSearchHistories(params),
    )
  }
}

export default new HeaderDomesticSearchService()
